<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">利用登録／変更</h1>
    </div>
    <h2 class="mt-5 mb-5">設定したい内容を<br>選んでください</h2>
    <div class="top-menu d-flex flex-wrap justify-content-center">
      <div class="box-p-20 text-center">
        <router-link to="/register" class="btn d-block mb-3 mx-5">ご利用登録</router-link>
        <p>会員サイト利用登録はこちら</p>
      </div>
      <div class="box-p-20 text-center">
        <router-link to="/settings" class="btn d-block mb-3 mx-5">設定変更</router-link>
        <p>会員サイト設定変更はこちら</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
@media screen and (min-width: 1px) and (max-width: 699px) {
  .top-menu .box-p-20 {
      width: 100%;
  }
}
</style>